export interface FeedbackButtonProps {
  id: string;
  floatingFeedbackButtonProps?: FloatingFeedbackButtonProps;
  onClick?: () => void;
}

export interface FloatingFeedbackButtonProps {
  top?: number;
  bottom?: number;
  right?: number;
  left?: number;
}

export const EVENT_SURVEY_ID = 'event-feedback-hotjar';